import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const subscribeNewsletter = (email, source = "site") =>
  api.post("/newsletter", { email, source }).then((r) => r.data);

export const sendContact = (payload) =>
  api.post("/contact", payload).then((r) => r.data);

export const listArticles = (category) =>
  api.get("/articles", { params: category ? { category } : {} }).then((r) => r.data);

export const getArticle = (slug) => api.get(`/articles/${slug}`).then((r) => r.data);

export const registerInterest = (email, area, note = "") =>
  api.post("/interest", { email, area, note }).then((r) => r.data);
